"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatterRequests = void 0;
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const OptionsHandler_1 = require("./IndexUtils/OptionsHandler");
class MatterRequests {
    constructor(session, profileId, appInfo) {
        this.getPairingCode = () => __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, {
                method: Paths_1.Methods.GET,
            }, this.opts);
            return (0, Utils_1.wrapFetchJson)(request, this.getEndpoint());
        });
        this.session = session;
        this.profileId = profileId;
        this.opts = new OptionsHandler_1.OptionsHandler(appInfo);
    }
    getEndpoint() {
        return `${this.session.baseUrl}/profiles/${this.profileId}/matter`;
    }
}
exports.MatterRequests = MatterRequests;
//# sourceMappingURL=MatterRequests.js.map